import React, { Component } from 'react';
import { Table, Input, Button, Icon } from 'antd';
import { List, Card } from 'antd';
import { Row, Col, Divider } from 'antd';
import { Steps } from 'antd';
import { Checkbox } from 'antd';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import openSocket from 'socket.io-client';
const Step = Steps.Step;
const Search = Input.Search;
const { Column } = Table;


class SelectedSegmentsGrid extends Component {
    constructor() {
        super();
        this.state = {
            segment: [],
            columnData: [],
            scrollY: 0,
            selectedRowKeys: []
        }
        // this.scrollY = 0;
        this.isFindBestMode = false;
        this.findBestData = [];
        this.moveRow = this.moveRow.bind(this);
    }

    components = {
        body: {
            row: DragableBodyRow,
        },
    }

    moveRow = (dragIndex, hoverIndex) => {
        const { segment } = this.state;
        const dragRow = segment[dragIndex];

        if (segment !== null && segment.length != 0 && !this.isEmptyObj(segment[0])) {
            this.recalaculate(segment[0].res_num);
        }

        this.props.updateStopsReorder(this.state.segment[dragIndex].res_num, this.state.segment[dragIndex].trip_id,
            this.state.segment[hoverIndex].trip_id, this.state.segment[dragIndex].stop_type.substring(0, 1).toUpperCase(),
            this.state.segment[hoverIndex].stop_type.substring(0, 1).toUpperCase(), (new Date(this.props.selectedDate)).toLocaleDateString());

        this.setState(
            update(this.state, {
                segment: {
                    $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
                },
            }),
        );
    }

    isEmptyObj(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return JSON.stringify(obj) === JSON.stringify({});
    }

    componentWillReceiveProps(theNextProps) {
        let aTempSegment = [];
        /* outterloop: for (var i = 0; i < this.props.schedulesBrief.length; i++) {
            if (this.props.schedulesBrief[i].selected) {
                for (var j = 0; j < this.props.schedules.length; j++) {
                    if (this.props.schedules[j].res_num === this.props.schedulesBrief[i].res_num) {
                        aTempSegment.push(this.props.schedules[j]);
                        aTempSegment[aTempSegment.length - 1].idx_in_trips = aTempSegment.length;
                    } else if (aTempSegment != null && aTempSegment.length != 0) {
                        break outterloop;
                    }
                }
            }
        } */
        outterloop: for (var i = 0; i < theNextProps.schedulesBrief.length; i++) {
            if (theNextProps.schedulesBrief[i].selected) {
                for (var j = 0; j < theNextProps.schedules.length; j++) {
                    if (theNextProps.schedules[j].res_num === theNextProps.schedulesBrief[i].res_num) {
                        aTempSegment.push(theNextProps.schedules[j]);
                        aTempSegment[aTempSegment.length - 1].idx_in_trips = aTempSegment.length;
                    } else if (aTempSegment != null && aTempSegment.length != 0) {
                        break outterloop;
                    }
                }
            }
        }
        if (aTempSegment === null || aTempSegment.length === 0 || this.arraysEqual(aTempSegment, this.state.segment)) {
            if (aTempSegment === null || aTempSegment.length === 0) {
                this.setState({ segment: aTempSegment, scrollY: this.props.scrollY });
            }
            return;
        }
        if (aTempSegment != null && aTempSegment.length != 0) {
            if (document.getElementById("myRightBottomNav").hidden) {
                document.getElementById("myRightBottomNav").hidden = false;
            }
            // aTempSegment.push({});
        } else {
            if (!document.getElementById("myRightBottomNav").hidden) {
                document.getElementById("myRightBottomNav").hidden = true;
            }
        }
        this.setState({ segment: aTempSegment, scrollY: this.props.scrollY });
        this.initColumnData(aTempSegment);

        let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
        for (var i = 0; i < aRowSelectors.length; i++) {
            aRowSelectors[i].style.minWidth = "8px";
            aRowSelectors[i].style.width = "16px";
            aRowSelectors[i].style.padding = "6px";
        }

        document.getElementsByClassName("ant-table-thead")[1].children[0].children[1].style.width = "117px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[2].style.width = "57px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[3].style.width = "57px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[4].style.width = "57px";
        for (var i = 0; i < document.getElementsByClassName("ant-table-tbody")[2].children.length; i++) {
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].style.width = "117px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].style.width = "101px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].children[0].style.width = "101px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[2].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].children[0].style.width = "40px";
        }

        if (this.isFindBestMode && this.findBestData != null && this.findBestData.length != 0) {
            let aIsScrolled = false;
            for (var i = 0; i < aTempSegment.length; i++) {
                if (parseInt(aTempSegment[i].stop_num) == parseInt(this.findBestData[0].PUSTP) - 1 || parseInt(aTempSegment[i].stop_num) == parseInt(this.findBestData[0].DOSTP) - 1) {
                    if (document.getElementsByClassName("ant-table-tbody")[2].children.length > i) {
                        document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].style.backgroundColor = "#2ACD3F";
                        if (!aIsScrolled) {
                            document.getElementsByClassName("ant-table-body")[2].scrollTo(0, document.getElementsByClassName("ant-table-tbody")[2].children[i].offsetHeight * i);
                            aIsScrolled = true;
                        }
                    }
                }
            }
        }
    }

    componentDidMount() {
        /* window.document.getElementsByClassName("ant-table-thead")[1].children[0].cells[1].width = "100px";
        window.document.getElementsByClassName("ant-table-thead")[1].children[0].cells[2].width = "66px";
        window.document.getElementsByClassName("ant-table-thead")[1].children[0].cells[3].width = "66px";
        window.document.getElementsByClassName("ant-table-thead")[1].children[0].cells[4].width = "66px"; */
        let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
        for (var i = 0; i < aRowSelectors.length; i++) {
            aRowSelectors[i].style.minWidth = "8px";
            aRowSelectors[i].style.width = "16px";
            aRowSelectors[i].style.padding = "6px";
        }

        document.getElementsByClassName("ant-table-thead")[1].children[0].children[1].style.width = "117px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[2].style.width = "57px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[3].style.width = "57px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[4].style.width = "57px";
        for (var i = 0; i < document.getElementsByClassName("ant-table-tbody")[2].children.length; i++) {
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].style.width = "117px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].style.width = "101px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].children[0].style.width = "101px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[2].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].children[0].style.width = "40px";
        }


        let aMaxHeight = window.innerHeight - 405;
        let aProtentialHeight = this.state.segment.length * 138;
        if (aProtentialHeight >= aMaxHeight) {
            // use aMaxHeight as scrollYHeight
            // this.setState({ scrollY: aMaxHeight })
            // this.scrollY = aMaxHeight;
            // this.props.updateRightBottomSideNavHeight(aMaxHeight);
        } else {
            // use aProtentialHeight as scrollYHeight
            // this.setState({ scrollY: aProtentialHeight })
            // this.scrollY = aProtentialHeight;
            // this.props.updateRightBottomSideNavHeight(aProtentialHeight);
        }

        if (this.isFindBestMode && this.findBestData != null && this.findBestData.length != 0) {
            let aIsScrolled = false;
            for (var i = 0; i < this.state.segment.length; i++) {
                if (parseInt(this.state.segment[i].stop_num) == parseInt(this.findBestData[0].PUSTP) - 1 || parseInt(this.state.segment[i].stop_num) == parseInt(this.findBestData[0].DOSTP) - 1) {
                    if (document.getElementsByClassName("ant-table-tbody")[2].children.length > i) {
                        document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].style.backgroundColor = "#2ACD3F";
                        if (!aIsScrolled) {
                            document.getElementsByClassName("ant-table-body")[2].scrollTo(0, document.getElementsByClassName("ant-table-tbody")[2].children[i].offsetHeight * i);
                            aIsScrolled = true;
                        }
                    }
                }
            }
        }
    }

    componentDidUpdate() {
        let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
        for (var i = 0; i < aRowSelectors.length; i++) {
            aRowSelectors[i].style.minWidth = "8px";
            aRowSelectors[i].style.width = "16px";
            aRowSelectors[i].style.padding = "6px";
        }

        let aMaxHeight = window.innerHeight - 405;
        let aProtentialHeight = this.state.segment.length * 138;
        if (aProtentialHeight >= aMaxHeight) {
            // use aMaxHeight as scrollYHeight
            // this.setState({ scrollY: aMaxHeight })
            // this.scrollY = aMaxHeight;
            // this.props.updateRightBottomSideNavHeight(aMaxHeight);
        } else {
            // use aProtentialHeight as scrollYHeight
            // this.setState({ scrollY: aProtentialHeight })
            // this.scrollY = aProtentialHeight;
            // this.props.updateRightBottomSideNavHeight(aProtentialHeight);
        }
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[1].style.width = "117px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[2].style.width = "57px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[3].style.width = "57px";
        document.getElementsByClassName("ant-table-thead")[1].children[0].children[4].style.width = "57px";
        for (var i = 0; i < document.getElementsByClassName("ant-table-tbody")[2].children.length; i++) {
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].style.width = "117px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].style.width = "101px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].children[0].style.width = "101px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[2].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].style.width = "57px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].style.width = "40px";
            document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].children[0].style.width = "40px";
        }

        if (this.isFindBestMode && this.findBestData != null && this.findBestData.length != 0) {
            let aIsScrolled = false;
            for (var i = 0; i < this.state.segment.length; i++) {
                if (parseInt(this.state.segment[i].stop_num) == parseInt(this.findBestData[0].PUSTP) - 1 || parseInt(this.state.segment[i].stop_num) == parseInt(this.findBestData[0].DOSTP) - 1) {
                    if (document.getElementsByClassName("ant-table-tbody")[2].children.length > i) {
                        document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].style.backgroundColor = "#2ACD3F";
                        if (!aIsScrolled) {
                            document.getElementsByClassName("ant-table-body")[2].scrollTo(0, document.getElementsByClassName("ant-table-tbody")[2].children[i].offsetHeight * i);
                            aIsScrolled = true;
                        }
                    }
                }
            }
        }
    }

    arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length != b.length) return false;
        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }

    initColumnData(theSegment) {
        let aColumnData = [];
        if (typeof theSegment !== "undefined" && theSegment !== null && theSegment.length !== 0) {
            let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
            let aStatusStyle = { marginRight: 2, borderTopLeftRadius: 50, borderTopRightRadius: 50, borderBottomLeftRadius: 50, borderBottomRightRadius: 50, width: 26, height: 26, background: '#2ACD3F' };
            for (var i = 0; i < theSegment.length; i++) {
                if (theSegment[i].stop_type.toUpperCase() === 'PICKUP') {
                    aBodyStyle = { padding: 8, backgroundColor: "gold", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                } else {
                    aBodyStyle = { padding: 8, backgroundColor: "Ivory", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                }
                if (theSegment[i].client_name !== null && theSegment[i].res_num !== null && theSegment[i].client_name.toUpperCase() === theSegment[i].res_num.toUpperCase()) {
                    aBodyStyle = { padding: 8, backgroundColor: "#1890ff", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                    aStatusStyle = { display: 'none', marginRight: 2, borderTopLeftRadius: 50, borderTopRightRadius: 50, borderBottomLeftRadius: 50, borderBottomRightRadius: 50, width: 26, height: 26, background: '#2ACD3F' };
                } else {
                    aStatusStyle = { display: 'none', marginRight: 2, borderTopLeftRadius: 50, borderTopRightRadius: 50, borderBottomLeftRadius: 50, borderBottomRightRadius: 50, width: 26, height: 26, background: '#2ACD3F' };
                }
                aColumnData.push({
                    key: (i + 1).toString(),
                    idx_in_trips: (i + 1).toString(),
                    segment_info:
                        <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
                            bordered={false} type="inner" >
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}><b>{this.convertMinutesToAmPm(theSegment[i].triptime)}</b></font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginLeft: 8 }}><b>{theSegment[i].client_name.toUpperCase()}</b></font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2, marginRight: 3 }}>{"ETA: " + this.convertMinutesToAmPm(theSegment[i].eta)}</font>
                                </Col>
                                <Col>
                                    <Divider type="vertical" style={{ backgroundColor: 'darkgrey' }} />
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginLeft: 3, marginRight: 3 }}>{"ETD: " + this.convertMinutesToAmPm(theSegment[i].eta)}</font>
                                </Col>
                                <Col>
                                    <Divider type="vertical" style={{ backgroundColor: 'darkgrey' }} />
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginLeft: 3 }}>{"ACT: " + this.convertMinutesToAmPm(theSegment[i].triptime)}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2, marginRight: 2 }}>{theSegment[i].address}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>{theSegment[i].citystate}</font>
                                </Col>
                                <Col>
                                    <div style={aStatusStyle}></div>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2, marginRight: 2 }}>Note: </font><font size="2" style={{ marginLeft: 2 }}>{theSegment[i].driver_notes}</font>
                                </Col>
                            </Row>
                        </Card>
                    /* segment_info:
                        <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
                            bordered={false} type="inner" >
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}><b>{theSegment[i].client_name.toUpperCase()}</b></font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginRight: 26 }}>{this.convertMinutesToAmPm(theSegment[i].eta)}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>{theSegment[i].address}</font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginRight: 2 }}><b>{this.convertMinutesToAmPm(theSegment[i].triptime)}</b></font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>{theSegment[i].citystate}</font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginRight: 26 }}>{this.convertMinutesToAmPm(theSegment[i].etd)}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>Note: </font><font size="2" style={{ marginLeft: 2 }}>{theSegment[i].driver_notes}</font>
                                </Col>
                            </Row>
                        </Card> */
                });
            }
        }
        this.setState({ columnData: aColumnData, selectedRowKeys: [] });
    }

    recalaculate(theResunm) {
        let socket = openSocket(this.props.GSENodeJsUrl);
        let aThisContext = this;
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
        });
        console.log("Sending -c with: " + this.props.userName + "~" + theResunm + "~" + "1" + "~" + this.props.selectedDate.replace("-20", "-"));
        socket.emit("-c", this.props.userName, theResunm, 1, this.props.selectedDate.replace("-20", "-"));
    }

    onRowClick(theRow) {
        console.log(theRow);
        this.props.updateStopSelection(parseInt(theRow.idx_in_trips) - 1);
    }

    onRowSelectChange(theKeys, theRows) {
        console.log(theRows);
        this.setState({ selectedRowKeys: theKeys });
        this.props.updateStopSelections(theRows);
    }

    getRowClassName(theRecord) {
        let aClassName = "";
        if (theRecord.stop_type.toUpperCase() === 'PICKUP') {
            aClassName = "row_class_name_pu";
        } else {
            aClassName = "row_class_name_do";
        }
        if (theRecord.client_name !== null && theRecord.res_num !== null && theRecord.client_name.toUpperCase() === theRecord.res_num.toUpperCase()) {
            aClassName = "row_class_name_garage";
        }
        return aClassName;
    }

    setFindBest(theData) {
        this.isFindBestMode = true;
        this.findBestData = theData;
    }

    clearFindBest() {
        this.isFindBestMode = false;
        this.findBestData = [];
    }

    render() {
        const columns = [{
            title: 'Client Name',
            dataIndex: 'client_name',
            width: 150,
        }, {
            title: 'ETA',
            dataIndex: 'eta',
            width: 150,
        }, {
            title: 'ETD',
            dataIndex: 'etd',
        }, {
            title: 'Address',
            dataIndex: 'address',
        }];

        // rowSelection object indicates the need for row selection
        const rowSelection = {
            hideDefaultSelections: false,
            columnWidth: 20,
            fixed: false,
            selections: false,
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                this.onRowSelectChange(selectedRowKeys, selectedRows);
            },
            getCheckboxProps: record => ({
                // disabled: record.name === 'Disabled User', // Column configuration not to be checked
                // name: record.name,
            }),
            onSelect: (record, selected, selectedRows, nativeEvent) => {
                // this.onRowSelect(record);
            },
            onSelectAll: (record, selected, selectedRows, nativeEvent) => {
                // this.onAllRowsSelect(record);
            }
        };
        return (
            <div>
                <Table bordered dataSource={this.state.segment} pagination={false} size="small" style={{ width: 670, backgroundColor: "rgba(255, 255, 255,0)" }} scroll={{ y: this.state.scrollY }}
                    rowClassName={(record) => this.getRowClassName(record)}
                    rowSelection={rowSelection}
                    components={this.components}
                    /* onRow={(record) => {
                        return {
                            onClick: () => { this.onRowClick(record) }
                        };
                    }} */
                    onRow={(record, index) => ({
                        index,
                        moveRow: this.moveRow,
                        // onClick: this.onRowClick,
                        onClick: () => { this.onRowClick(record) }
                    })}
                >
                    <Column
                        title="Client Name"
                        key="clientName"
                        render={(text, record) => (
                            <div style={{ overflow: "hidden", whiteSpace: "nowrap" }} >
                                <p>{record.client_name}</p>
                            </div>
                        )}
                    />
                    <Column
                        title="PRM"
                        key="promissTime"
                        render={(text, record) => (
                            <div style={{ overflow: "hidden", whiteSpace: "nowrap" }} >
                                <p>{this.convertMinutesToAmPm(record.triptime)}</p>
                            </div>
                        )}
                    />
                    <Column
                        title="ETA"
                        key="eta"
                        render={(text, record) => (
                            <div style={{ overflow: "hidden", whiteSpace: "nowrap" }} >
                                <p>{this.convertMinutesToAmPm(record.eta)}</p>
                            </div>
                        )}
                    />
                    <Column
                        title="ETD"
                        key="etd"
                        render={(text, record) => (
                            <div style={{ overflow: "hidden", whiteSpace: "nowrap" }} >
                                <p>{this.convertMinutesToAmPm(record.etd)}</p>
                            </div>
                        )}
                    />
                    <Column
                        title="Address"
                        key="address"
                        render={(text, record) => (
                            <div style={{ overflow: "hidden", whiteSpace: "nowrap" }} >
                                <p>{record.address + ", " + record.citystate}</p>
                            </div>
                        )}
                    />
                </Table>
            </div>
        );
    }

    convertMinutesToAmPm(pMins) {
        let theMins = -1;
        if (pMins !== null && typeof pMins === "string" && pMins.length != 0) {
            theMins = parseInt(pMins);
        } else if (typeof pMins === "number") {
            theMins = pMins;
        }
        if (theMins < 0) {
            return "";
        }
        let aIsAm = true;
        if (theMins >= 12 * 60) {
            aIsAm = false;
        }
        let aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        if (aIsAm) {
            if (aIsAm === 0) {
                return "0000A";
            }
            aHr = Math.floor(theMins / 60);
            aMin = theMins % 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "A";
        } else {
            if (theMins === 12 * 60) {
                return "1200P";
            }
            aHr = Math.floor((theMins - 12 * 60) / 60);
            aMin = (theMins - 12 * 60) % 60;
            if (aHr < 10) {
                if (aHr === 0) {
                    aHrStr = "12";
                } else {
                    aHrStr = "0" + aHr.toString();
                }
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "P";
        }
    }
}


function dragDirection(
    dragIndex,
    hoverIndex,
    initialClientOffset,
    clientOffset,
    sourceClientOffset,
) {
    const hoverMiddleY = (initialClientOffset.y - sourceClientOffset.y) / 2;
    const hoverClientY = clientOffset.y - sourceClientOffset.y;
    if (dragIndex < hoverIndex && hoverClientY > hoverMiddleY) {
        return 'downward';
    }
    if (dragIndex > hoverIndex && hoverClientY < hoverMiddleY) {
        return 'upward';
    }
}

class BodyRow extends React.Component {
    render() {
        const {
            isOver,
            connectDragSource,
            connectDropTarget,
            moveRow,
            dragRow,
            clientOffset,
            sourceClientOffset,
            initialClientOffset,
            ...restProps
        } = this.props;
        const style = { ...restProps.style, cursor: 'move' };

        let className = restProps.className;
        if (isOver && initialClientOffset) {
            const direction = dragDirection(
                dragRow.index,
                restProps.index,
                initialClientOffset,
                clientOffset,
                sourceClientOffset
            );
            if (direction === 'downward') {
                className += ' drop-over-downward';
            }
            if (direction === 'upward') {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(
                <tr
                    {...restProps}
                    className={className}
                    style={style}
                />
            )
        );
    }
}

const rowSource = {
    beginDrag(props) {
        return {
            index: props.index,
        };
    },
};

const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    sourceClientOffset: monitor.getSourceClientOffset(),
}))(
    DragSource('row', rowSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        dragRow: monitor.getItem(),
        clientOffset: monitor.getClientOffset(),
        initialClientOffset: monitor.getInitialClientOffset(),
    }))(BodyRow)
);




// export default SelectedSegmentsGrid;
export default DragDropContext(HTML5Backend)(SelectedSegmentsGrid);



// WEBPACK FOOTER //
// ./src/Componets/SelectedSegmentsGrid.js